import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/components/collections/modal-manager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/context/ua-parser.ts");
